<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { getContext } from "svelte";

    import SettingsNav from "../settingsnav.svelte";
    import PropertiesList from "./list.svelte";
    import PropertyManage from "./manage.svelte";

    import {
        managePropertiesMeta
    } from "../../../utils/session";

    import {
        errorReasons,
        userProfile,
        listProperties,
        disableProperty
    } from "../../api.svelte";


    const router = getContext('router');

    const PAGE_TITLES = {
        'locations': 'Standorte',
        'edit': 'Standort bearbeiten',
        'create': 'Standort erstellen'
    };


    let profile;
    let properties;

    let currentView = 'locations';
    let currentPropertyId = false;

    let confirmationDialog = false;


    onMount(() => {

        getUserProfile();

        getPropertiesList();

    });

    $: showBackButton = () => {

        return currentView !== 'locations';
    };

    $: showDeleteButton = () => {

        return currentView === 'edit';
    };

    $: getPageTitle = () => {

        return PAGE_TITLES[currentView];
    };

    $: getPropertyData = () => {

        if (!currentPropertyId) return false;

        if (!Object.keys(properties).includes(currentPropertyId)) {

            return false;
        }

        return properties[currentPropertyId];

    };

    $: getPropertyName = () => {

        if (!currentPropertyId) return false;

        return properties[currentPropertyId]['details']['name'];

    };

    let getUserProfile = () => {

        userProfile().then((profileResult) => {

            if (profileResult['status'] !== 'success') {

                // TODO: Handle errore
                console.log(profileResult);

                return;

            }

            profile = profileResult['profile'];

        });

    };

    let getPropertiesList = () => {

        listProperties().then((listResult) => {

            if (listResult['status'] !== 'success') {

                // TODO: Handle errore
                console.log(listResult);

                return;

            }

            properties = listResult['properties'];

            managePropertiesMeta(properties);

        });

    };

    const backButtonHandler = (evt) => {

        currentPropertyId = false;
        currentView = 'locations';

    };

    const deleteButtonHandler = (evt) => {

        confirmationDialog = true;
    };

    let deleteProperty = () => {

        confirmationDialog = false;

        disableProperty(currentPropertyId).then((disableResult) => {

            if (disableResult['status'] !== 'success') {

                // TODO: Handle errore
                console.log(disableResult);

                return;

            }

            currentPropertyId = false;
            currentView = 'locations';

            getPropertiesList();

        });

    };

    let cancelDeleteProperty = () => {

        confirmationDialog = false;
    };

    const previewClickedHandler = (evt) => {

        currentPropertyId = evt.detail['propertyid'];
        currentView = 'edit';

    };

    const previewCreateHandler = (evt) => {

        currentView = 'create';
    };

    const propertyCreatedHandler = (evt) => {

        getPropertiesList();

        currentPropertyId = evt.detail['propertyid'];

    };

    const propertySavedHandler = (evt) => {

        getPropertiesList();
    };

</script>


<div class="settings-wrapper">

    <SettingsNav
            active="locations"
            showBack={showBackButton()}
            showDelete={showDeleteButton()}
            on:back={backButtonHandler}
            on:delete={deleteButtonHandler} />

    <h2>{getPageTitle()}</h2>

    {#if currentView === 'locations'}

        <div id="properties-list">

            <PropertiesList
                    properties={properties}
                    numAvailable={(profile) ? profile['numavailable'] : 0}
                    on:preview={previewClickedHandler}
                    on:create={previewCreateHandler} />

        </div>

    {:else}

        <div id="property-manage">

            <PropertyManage
                    propertyId={currentPropertyId}
                    propertyData={getPropertyData()}
                    on:created={propertyCreatedHandler}
                    on:saved={propertySavedHandler} />

        </div>

    {/if}

    {#if confirmationDialog}

        <div id="delete-confirmation" class="forms-container modal">

            <div class="modal-title">
                Möchten Sie diesen Standort <span class="highlight">{getPropertyName()}</span> wirklich entfernen?
            </div>

            <div class="modal-buttons">

                <button
                        class="btn half"
                        on:click|preventDefault={() => cancelDeleteProperty()} >

                    <span>Abbrechen</span>

                </button>

                <button
                        class="btn danger half"
                        on:click|preventDefault={() => deleteProperty()} >

                    <span>Entfernen</span>

                </button>

            </div>

        </div>

    {/if}

</div>


<style>

    #properties-list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 5vh;
        height: 55vh;
    }

    #property-manage {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 80vh;
    }

</style>
